import { Card } from 'nhsuk-react-components';
import homePageCards from 'utils/homePageCards.ts';
import ActivityBanner from 'components/Home/ActivityBanner';
import featureFlags from 'services/featureFlags.ts';
import { Link } from 'react-router-dom';
import './Home.scss';

export default function Home() {
  return (
    <div className="nhsuk-u-margin-top-6">
      <Card>
        <>
          <h2>
            Welcome to SPI
          </h2>
          <p>
            Use this page to access different sections of the SPI application.
          </p>
        </>
      </Card>

      {featureFlags.notificationsEnabled && <ActivityBanner />}

      <Card>
        <h3>Choose an option</h3>

        <div className="nhsuk-grid-row home-page-card-grid">
          {homePageCards
            .map((card) => (
              <div key={card.url} className="nhsuk-grid-column-one-third home-page-card-column">
                <Card className="home-page-card">
                  <>
                    <h4 className="nhsuk-u-margin-bottom-3">
                      <Link
                        className="nhsuk-u-font-weight-bold nhsuk-u-margin-bottom-3"
                        to={card.url}
                        target={card.target}
                        aria-label={card.ariaLabel}
                        rel={card.rel}
                      >
                        {card.title}
                      </Link>
                    </h4>
                    <p>{card.description}</p>
                  </>
                </Card>
              </div>
            ))}
        </div>
      </Card>
    </div>
  );
}
